import React, {useEffect} from 'react';
import {useSelector, useDispatch} from "react-redux";
import {Link, useParams} from "react-router-dom";
import {Alert, Button, FormControl} from "react-bootstrap";
import {Helmet} from "react-helmet";
import moment from "moment";
import * as t from "counterpart";
import {loadCart, changeQuantity, deleteItem} from "./actions";

import "./style/Cart.scss";
import PaymentHooks from "../Commerce/PaymentHooks";
import ProductBadges from "../Commerce/Blocks/ProductBadges";

function Cart()
{
	const dispatch = useDispatch();
	const user = useSelector(state => state.portal.user);
	const cart = useSelector(state => state.cart);
	const store = useParams().store;
	const localCart = !user;

	useEffect(() => dispatch(loadCart(localCart)), [user, dispatch, localCart]);

	const onDelete = (id) => dispatch(deleteItem(id, localCart));
	const onChangeQuantity = (id, quantity) => dispatch(changeQuantity(id, quantity, localCart));

	let total = 0;
	let totalSaved = 0;
	let totalCashBack = 0;

	const renderItem = (item, cashBack, editable=true) =>
	(
		<div key={item.cart_id} className="product row">
			{!!item.cart_price && item.cart_price !== item.current_price &&
				<Alert variant="warning">
					<i className="fa fa-warning" style={{marginLeft: 5}} />
					{t("This item price changed since you add it to your cart")} ({(item.current_price - item.cart_price || 0).toLocaleString()})
				</Alert>}

			<div className="image col-md-2" style={{backgroundImage: "url('"+item.thumbnail+"')"}} />

			<div className="details col-md-6">
				<h3>{item.name}</h3>
				<h6>{item.parent_name}</h6>
				{item.cart_expiration && <h5 style={{color: "red"}}>{t("Expires")}: {moment(item.cart_expiration).fromNow()}</h5>}
				<div> {item.current_price === 0 ? t("Free") : (item.current_price * item.cart_quantity).toLocaleString()+" "+window.portalSetting("commerce.currency")}</div>
				{!!item.cart_options_price &&<div>{t("Additional Options") +" "+ (item.cart_options_price * item.cart_quantity).toLocaleString()+" "+window.portalSetting("commerce.currency")}</div>}
			</div>

			<div className="price-box col-md-4">
				<div>
					{!!item.saved_amount && <div className="old-price">{item.price.toLocaleString()} {window.portalSetting("commerce.currency")}</div>}
					<div className="price"> {item.current_price === 0 ? t("Free") : ((item.current_price + item.cart_options_price - cashBack) * item.cart_quantity).toLocaleString()+" "+window.portalSetting("commerce.currency")}</div>
					{!!item.saved_amount && <div className="saved-amount">{t("saved_amount")} {item.saved_amount * item.cart_quantity} {window.portalSetting("commerce.currency")}</div>}
					{!!item.cash_back && <div className="saved-amount">{t("With %(amount)s %(currency)s cashback", {amount: item.cash_back * item.cart_quantity, currency: window.portalSetting("commerce.currency")})}</div>}
					{!!item.current_pric && <div className="note">{t("VAT Included")}</div>}
				</div>

				<div className="controls">
					<div className="quantity">
						<span>{t("Quantity")}</span>
						<FormControl
							type="number"
							min="1"
							value={item.cart_quantity}
							onChange={(e) => onChangeQuantity(item.cart_id, e.target.value)}
							disabled={!editable}
						/>
					</div>

					{editable && <Button className="delete" onClick={() => onDelete(item.cart_id)}>{t("Remove")} <i className="fa fa-trash" /></Button>}
				</div>
			</div>

			<ProductBadges product={item} />
		</div>
	)

	return (
		<div id="cart-page" className="container page-body">
			<h1><i className="fa fa-shopping-cart" />{t("Cart")} <span>({cart.items.length} {t("Items")})</span></h1>
			<Helmet>
				<title>{t("Cart")}</title>
			</Helmet>

			{cart.error && <Alert variant="danger">{cart.error}</Alert>}

			{cart.items.map(item =>
			{
				item.cart_options_price = item.cart_options_price || 0;

				const cashBack = item.cash_back || 0;
				total += (item.current_price + item.cart_options_price - cashBack) * item.cart_quantity;
				totalSaved += item.saved_amount * item.cart_quantity;
				totalCashBack += cashBack * item.cart_quantity;

				return [
					renderItem(item, cashBack),
					...(item.gifts || []).map(gift => {
						gift.cart_quantity = item.cart_quantity;
						gift.saved_amount = gift.current_price;
						gift.cart_price = 0;
						gift.current_price = 0;
						gift.cash_back = 0;

						totalSaved += gift.saved_amount * gift.cart_quantity;

						return renderItem(gift, 0, false);
					})
				];
			})}

			{cart.items.length !== 0 &&
			<div id="details">
				<PaymentHooks product={{current_price: total}} />

				<div id="total">
					{totalSaved !== 0 && <div className="saved">{t("Total Saved")}</div>}
					{totalSaved !== 0 && <div className="saved"> {totalSaved.toLocaleString()}</div>}
					{totalCashBack !== 0 && <div className="saved">{t("cash_back")}</div>}
					{totalCashBack !== 0 && <div className="saved"> {totalCashBack.toLocaleString()}</div>}
					<div>{t("Cart Total")}</div>
					<div> {total.toLocaleString()}</div>
					{user && <Link to={"/"+store+"/cart/order"}> <i className="fa fa-money-bill" />{t("Continue To Checkout")}</Link>}
					{!user && <Link to={`/${store}/auth/login?form=/${store}/cart`}> <i className="fa fa-user-alt" />{t("Continue To Checkout")}</Link>}
				</div>
			</div>}
		</div>
	)
}

export default Cart;
